import { useParams, useSearchParams } from 'next/navigation';

import { getFamilyPlanParams } from '@/components/familyPlan/FamilyPlanLanding';

import { useGetInviteLinkHash } from './useCreateInviteLink';

export function useFamilyParams(isJoinFlow: boolean) {
	// We're moving join token generation from frontend to backend.
	// - New flow (backend): token comes via AppsFlyer's 'deep_link_value' parameter
	// - Old flow (frontend): token comes via 'familyParams' parameter
	// This checks if we're using the new backend-generated flow
	const searchParams = useSearchParams();
	const params = useParams();

	const isUpdatedFlow = params?.familyParams === undefined;

	const familyParamsHashRaw =
		isJoinFlow && isUpdatedFlow ? searchParams?.get('deep_link_value') : params?.familyParams;
	const familyParamsHash =
		typeof familyParamsHashRaw === 'string' ? familyParamsHashRaw : familyParamsHashRaw?.[0];

	const { data, isLoading } = useGetInviteLinkHash(familyParamsHash, isUpdatedFlow);
	const familyParams = data ?? getFamilyPlanParams(familyParamsHash);

	return {
		familyParams,
		isLoading,
		familyParamsHash,
	};
}
